import React, { Component } from 'react';
import Header from './Header';
import DocsMenu from './DocsMenu';
import Main from './Main';
import './../App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <DocsMenu />
        <Main />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js